import React, { PropTypes } from 'react';
import _ from 'lodash';

class Autocomplete extends React.Component {

    constructor(props) {
        super(props);

        var self = this;

        self.state = {
            place: self.props.defaultPlace || null
        };
    }

    componentDidMount() {
        var self = this;

        if (self.refs.locationInput != null && self.autocomplete == null) {

            if (self.state.place != null) {
                self.refs.locationInput.value = self.state.place.name ? 
                    `${self.state.place.name}, ${self.state.place.address}` : self.state.place;
            }

            self.autocomplete = new google.maps.places.Autocomplete(self.refs.locationInput, {});

            self.autocomplete.addListener('place_changed', self.onPlaceChanged);
        }
    }

    invokeChangeHandler = () => {
        var self = this;

        if (self.props.onChange != null && typeof self.props.onChange === 'function') {
            self.props.onChange(self.state.place);
        }
    }

    onPlaceChanged = () => {
        var self = this,
            place = self.autocomplete.getPlace(),
            name = place.name,
            photos = [];

        if (!place.place_id) {
            self.refs.locationInput.value = '';
            return;
        }

        if (!name || name === '') {
            let components = parseAddressComponents(place.address_components);

            if (components.establishment) {
                name = components.establishment;
            }
            else if (components.country) {
                name = (components.locality || components.administrative_area_level_1 || 'Unknown') + ', ' + components.country;
            }
        }

        if (place.photos && place.photos.length) {
            photos = place.photos.map(photo => {
                return photo.getUrl({ maxWidth: 640, maxHeight: 480 });
            });
        }

        place = {
            location: {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng()
            },
            id: place.place_id,
            name: name,
            photos: photos,
            address: place.formatted_address,
            url: place.url
        };

        self.setState({
           place: place
        }, () => {
            self.invokeChangeHandler();
        });
    }

    onValueChanged = (e) => {
        var self = this,
            value = self.refs.locationInput.value;

        if (value == null || (typeof value === 'string' && value.trim() == '')) {
            self.setState({
                place: null
            }, () => {
                self.invokeChangeHandler();
            });
        }
        else if (self.props.requireResolvedPlace !== true) {
            self.setState({
                place: value
            }, () => {
                self.invokeChangeHandler();
            });
        }
    }

    render () {
        var self = this,
            inputProps;

        inputProps = _.omit(self.props, ['defaultPlace', 'onChange', 'requireResolvedPlace']);

        return (
            <input type="text" ref="locationInput" className="form-control" onChange={ self.onValueChanged } { ...inputProps } />
        );
    }
};

export default Autocomplete;


// WEBPACK FOOTER //
// ./src/app/components/places/autocomplete.jsx